import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Handles magic link login via root URL or redirects based on auth token
 */
const MagicLinkHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mode = params.get("mode");
    const oobCode = params.get("oobCode");
    const token = localStorage.getItem("token");

    if (mode === "signIn" && oobCode) {
      // If magic link params exist, forward to login with query params
      navigate(`/login?${params.toString()}`, { replace: true });
    } else if (token) {
      // If already logged in (token exists), forward to main dashboard
      navigate("/super-admin/clubs", { replace: true });
    } else {
      // Fallback: not logged in, no magic link → go to login
      navigate("/login", { replace: true });
    }
  }, [navigate, location.search]);

  return null;
};

export default MagicLinkHandler;
